/* Yumeka — popup lot Nuage sur la fiche couette (11 oct).
   Copie de upsell.js : la couette ajoutee, la fenetre propose 2 oreillers
   Nuage (1 achete = 1 offert), envoyes avec la propriete _bundlex comme
   « Ajouter les 2 » du panier (yk-packs.js) : sans elle, BundleX ne
   reconnait pas le lot et la caisse facturerait les deux. Le prix d une
   variante est celui des DEUX oreillers ; le prix barre, deux oreillers payes.
   upsell.js reste inchange pour l offre couette des fiches oreillers.
   Commentaires detailles du reste du fonctionnement : voir upsell.js. */
(function () {
  'use strict';
  if (!window.fetch || !window.Promise) return;
  var racine = document.querySelector('[data-upsell]');
  if (!racine) return;
  var $  = function (s, r) { return (r || racine).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || racine).querySelectorAll(s)); };
  var variantes = [];
  try { variantes = JSON.parse($('[data-upsell-json]').textContent) || []; } catch (e) { return; }
  if (!variantes.length) return;
  var declencheurs = (racine.getAttribute('data-triggers') || '').split(',').filter(Boolean);
  var formatArgent = racine.getAttribute('data-money-format') || '{{amount}}';
  var remise = parseInt(racine.getAttribute('data-discount'), 10) || 0;
  var lot = parseInt(racine.getAttribute('data-pack'), 10) || 0;
  var bxD = racine.getAttribute('data-bx-d');
  var bxO1 = Number(racine.getAttribute('data-bx-o1'));
  if (lot && !(bxD && bxO1)) return;
  var carte    = $('[data-upsell-card]');
  var piste    = $('[data-upsell-stage]');
  var prixEl   = $('[data-upsell-price]');
  var barreEl  = $('[data-upsell-compare]');
  var gainEl   = $('[data-upsell-save]');
  var erreurEl = $('[data-upsell-error]');
  var ouiEl    = $('[data-upsell-accept]');
  var ouiLabelEl = $('[data-upsell-cta-label]') || ouiEl;
  var ecoEl    = $('[data-upsell-eco]');
  var bandeEl  = $('[data-upsell-thumbs]');
  var compteEl = $('[data-upsell-count]');
  var mEl = $('[data-upsell-m]');
  var sEl = $('[data-upsell-s]');
  var horloge = null;
  var destination = '/cart';
  var focusAvant = null;
  var quantite = 1;

  function argent(cents) {
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var entier = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var rendu = entier + ',' + parts[1];
    return formatArgent.replace(/\{\{\s*amount[^}]*\}\}/, rendu);
  }

  function choix() {
    return $$('[data-upsell-opt]').map(function (s) { return s.value; });
  }

  function varianteCourante() {
    var c = choix();
    return variantes.filter(function (v) {
      return c.every(function (val, i) { return v.options[i] === val; });
    })[0] || null;
  }

  function poserLibelle(txt) { ouiLabelEl.textContent = txt; }

  function majGain(ref, net) {
    if (!ecoEl) return;
    if (!(ref > net)) { ecoEl.hidden = true; return; }
    var tpl = ecoEl.getAttribute('data-tpl') || '{amount}';
    ecoEl.textContent = tpl.replace('{amount}', argent(ref - net));
    ecoEl.hidden = false;
  }

  function rafraichir() {
    var v = varianteCourante();
    if (!v) {
      ouiEl.disabled = true;
      montrerErreur('Cette combinaison n’est pas disponible.');
      return;
    }
    ouiEl.disabled = !v.available || racine.classList.contains('is-expire');
    if (!v.available) montrerErreur('Ce coloris est épuisé pour le moment.');
    else cacherErreur();
    var net = prixAnnonce(v);
    var ref = lot ? v.price * lot : (remise > 0 ? v.price : v.compare_at_price);
    prixEl.textContent = argent(net);
    if (ref > net) {
      barreEl.textContent = argent(ref);
      barreEl.hidden = false;
      gainEl.textContent = '−' + Math.round((ref - net) * 100 / ref) + ' %';
      gainEl.hidden = false;
    } else {
      barreEl.hidden = true;
      gainEl.hidden = true;
    }
    majGain(ref, net);
    if (v.image) montrer(v.image, premierRendu);
    var coloris = choix()[0];
    $$('[data-upsell-swatch]').forEach(function (t) {
      t.setAttribute('aria-pressed', t.getAttribute('data-upsell-swatch') === coloris ? 'true' : 'false');
    });
    var nomEl = $('[data-upsell-color-name]');
    if (nomEl) nomEl.textContent = coloris;
    premierRendu = false;
  }

  function prixAnnonce(v) {
    if (!(remise > 0)) return v.price;
    return Math.round(v.price * (100 - remise) / 100);
  }

  var premierRendu = true;

  function montrer(src, sansAnimation) {
    if (!piste) return;
    var cible = piste.querySelector('[data-upsell-slide="' + String(src).replace(/"/g, '') + '"]');
    if (cible) {
      var dx = cible.offsetLeft - piste.offsetLeft;
      var doux = !sansAnimation && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (piste.scrollTo) piste.scrollTo({ left: dx, behavior: doux ? 'smooth' : 'auto' });
      else piste.scrollLeft = dx;
    }
    allumerVignette(src);
  }

  function allumerVignette(src) {
    var nom = String(src).split('?')[0].split('/').pop();
    var actif = null;
    $$('[data-upsell-thumb]').forEach(function (b) {
      var n = String(b.getAttribute('data-upsell-thumb')).split('?')[0].split('/').pop();
      var on = n === nom;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) actif = b;
    });
    if (!actif || !bandeEl) return;
    var g = actif.offsetLeft - bandeEl.offsetLeft;
    var d = g + actif.offsetWidth;
    if (g < bandeEl.scrollLeft) bandeEl.scrollLeft = g - 6;
    else if (d > bandeEl.scrollLeft + bandeEl.clientWidth) bandeEl.scrollLeft = d - bandeEl.clientWidth + 6;
  }

  function initFleches() {
    var prev = $('[data-upsell-thumbs-prev]');
    var next = $('[data-upsell-thumbs-next]');
    if (!bandeEl || !prev || !next) return null;
    function pas() { return Math.max(120, Math.round(bandeEl.clientWidth * 0.8)); }
    function sync() {
      var max = bandeEl.scrollWidth - bandeEl.clientWidth;
      var deborde = max > 8;
      prev.hidden = !deborde || bandeEl.scrollLeft <= 8;
      next.hidden = !deborde || bandeEl.scrollLeft >= max - 8;
    }
    prev.addEventListener('click', function () { bandeEl.scrollBy({ left: -pas(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { bandeEl.scrollBy({ left: pas(), behavior: 'smooth' }); });
    bandeEl.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    return sync;
  }

  var syncFleches = initFleches();

  function montrerErreur(msg) { erreurEl.textContent = msg; erreurEl.hidden = false; }
  function cacherErreur() { erreurEl.textContent = ''; erreurEl.hidden = true; }

  function lancerDecompte() {
    var secondes = parseInt(racine.getAttribute('data-seconds'), 10) || 0;
    if (!(secondes > 0) || !mEl || !sEl) return;
    var depart = performance.now();
    horloge = setInterval(function () {
      var reste = Math.max(0, Math.round(secondes - (performance.now() - depart) / 1000));
      mEl.textContent = ('0' + Math.floor(reste / 60)).slice(-2);
      sEl.textContent = ('0' + (reste % 60)).slice(-2);
      if (reste <= 0) expirer();
    }, 250);
  }

  function arreterDecompte() {
    if (horloge) { clearInterval(horloge); horloge = null; }
  }

  function expirer() {
    arreterDecompte();
    racine.classList.add('is-expire');
    ouiEl.disabled = true;
    var phraseEl = $('[data-upsell-phrase]');
    if (phraseEl) phraseEl.textContent = 'Cette offre vient de se terminer.';
    setTimeout(refuser, 1200);
  }

  function ouvrir() {
    focusAvant = document.activeElement;
    racine.hidden = false;
    document.body.style.overflow = 'hidden';
    if (syncFleches) {
      syncFleches();
      if (window.requestAnimationFrame) window.requestAnimationFrame(syncFleches);
    }
    quantite = 1;
    if (compteEl) compteEl.textContent = '1';
    rafraichir();
    if (carte) { carte.scrollTop = 0; carte.focus(); }
    lancerDecompte();
    document.addEventListener('keydown', auClavier);
  }

  function partir() {
    arreterDecompte();
    document.removeEventListener('keydown', auClavier);
    document.body.style.overflow = '';
    if (focusAvant && focusAvant.focus) focusAvant.focus();
    racine.hidden = true;
    window.location.href = destination;
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted || racine.hidden) return;
    arreterDecompte();
    document.removeEventListener('keydown', auClavier);
    racine.hidden = true;
    document.body.style.overflow = '';
  });

  function refuser() {
    destination = '/cart';
    partir();
  }

  function auClavier(e) {
    if (e.key === 'Escape') { e.preventDefault(); refuser(); return; }
    if (e.key !== 'Tab') return;
    var cibles = $$('button, select, [href], input', carte).filter(function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!cibles.length) return;
    var premier = cibles[0], dernier = cibles[cibles.length - 1];
    if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
  }

  function accepter() {
    var v = varianteCourante();
    if (!v || !v.available) return;
    var attendu = prixAnnonce(v);
    ouiEl.disabled = true;
    poserLibelle('Ajout…');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [lot
        ? { id: v.id, quantity: lot, properties: { _bundlex: JSON.stringify({ d: bxD, o: 1, oid: bxO1 }) } }
        : { id: v.id, quantity: quantite }] })
    })
      .then(function (r) {
        return r.text().then(function (t) {
          var b = null;
          try { b = JSON.parse(t); } catch (e) { throw new Error('Le panier n’a pas répondu (' + r.status + ').'); }
          if (!r.ok) throw new Error(b.description || b.message || 'Ajout impossible.');
          return b;
        });
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; });
      })
      .then(function (panier) {
        var lignesV = panier ? panier.items.filter(function (it) {
          return String(it.variant_id) === String(v.id);
        }) : [];
        var ligne = lignesV[0];
        var facture = ligne ? ligne.final_price : 0;
        if (lot) {
          /* BundleX coupe le lot en deux lignes (dont une offerte) : on
             additionne les lignes _bundlex de ce coloris et on ne compare que
             si elles comptent exactement le lot (meme coloris deja au panier :
             le panier tranchera). */
          var lotLignes = lignesV.filter(function (it) { return it.properties && it.properties._bundlex; });
          var n = 0;
          facture = 0;
          lotLignes.forEach(function (it) { n += it.quantity; facture += it.final_line_price; });
          ligne = n === lot ? lotLignes[0] : null;
        }
        if (ligne && Math.abs(facture - attendu) > 1) {
          destination = '/cart';
          montrerErreur('Le prix appliqué est ' + argent(facture) + ', et non ' + argent(attendu) + '. Vérifiez votre panier avant de payer.');
          ouiEl.disabled = false;
          poserLibelle('Voir mon panier');
          ouiEl.removeEventListener('click', accepter);
          ouiEl.addEventListener('click', partir);
          arreterDecompte();
          return;
        }
        destination = '/cart';
        partir();
      })
      .catch(function (e) {
        ouiEl.disabled = false;
        poserLibelle(ouiEl.getAttribute('data-libelle') || 'Ajouter à ma commande');
        montrerErreur(e.message);
      });
  }

  ouiEl.setAttribute('data-libelle', ouiLabelEl.textContent.trim());
  ouiEl.addEventListener('click', accepter);
  $$('[data-upsell-decline]').forEach(function (b) { b.addEventListener('click', refuser); });
  $$('[data-upsell-opt]').forEach(function (s) { s.addEventListener('change', rafraichir); });

  if (piste) {
    var minuteurDefil = null;
    piste.addEventListener('scroll', function () {
      if (minuteurDefil) clearTimeout(minuteurDefil);
      minuteurDefil = setTimeout(function () {
        var x = piste.scrollLeft;
        var proche = null, ecart = Infinity;
        $$('[data-upsell-slide]', piste).forEach(function (dia) {
          var ecart2 = Math.abs((dia.offsetLeft - piste.offsetLeft) - x);
          if (ecart2 < ecart) { ecart = ecart2; proche = dia; }
        });
        if (proche) allumerVignette(proche.getAttribute('data-upsell-slide'));
      }, 120);
    }, { passive: true });
  }

  $$('[data-upsell-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var src = b.getAttribute('data-upsell-thumb');
      if (!src) return;
      montrer(src, false);
    });
  });

  $$('[data-upsell-swatch]').forEach(function (t) {
    t.addEventListener('click', function () {
      var premier = $('[data-upsell-opt="0"]');
      if (!premier) return;
      premier.value = t.getAttribute('data-upsell-swatch');
      rafraichir();
    });
  });

  $$('[data-upsell-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      quantite = Math.max(1, Math.min(10, quantite + Number(b.getAttribute('data-upsell-step'))));
      if (compteEl) compteEl.textContent = String(quantite);
    });
  });

  window.YKUpsell = {
    proposer: function (items, route) {
      try {
        if (!items || !items.length) return false;
        var declenche = items.some(function (it) {
          return declencheurs.indexOf(String(it.id)) !== -1;
        });
        if (!declenche) return false;
        destination = '/cart';
        ouvrir();
        return true;
      } catch (e) {
        return false;
      }
    }
  };
})();
